import type { WatchModule } from './watch-types';

/**
 * Fetches `watch.js` from the directory player.js came from, once. This module runs inside the
 * player bundle's IIFE, which executes synchronously when its script tag does, so
 * `document.currentScript` is player.js here (the same trick `help.ts` uses). An offline copy
 * keeps `p/player.js` and `p/watch.js` together; so do `/p/` on the share pages.
 */
const SELF: string | null =
  typeof document !== 'undefined' &&
  document.currentScript instanceof HTMLScriptElement &&
  document.currentScript.src
    ? document.currentScript.src
    : null;

let loading: Promise<WatchModule> | null = null;

export function loadWatch(): Promise<WatchModule> {
  if (globalThis.MadoWatch) return Promise.resolve(globalThis.MadoWatch);
  return (loading ??= new Promise<WatchModule>((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SELF ? SELF.replace(/[^/?#]*(?:[?#].*)?$/, 'watch.js') : '/p/watch.js';
    s.async = true;
    s.onload = () => {
      if (globalThis.MadoWatch) resolve(globalThis.MadoWatch);
      else {
        loading = null;
        reject(new Error('watch.js loaded without MadoWatch'));
      }
    };
    s.onerror = () => {
      loading = null;
      s.remove();
      reject(new Error('watch.js failed to load'));
    };
    document.head.appendChild(s);
  }));
}

/** Fetch Watch when the page is quiet, so Play is instant. */
export function warmWatch(): void {
  if (globalThis.MadoWatch) return;
  const go = (): void => void loadWatch().catch(() => {});
  if (typeof requestIdleCallback === 'function') requestIdleCallback(go, { timeout: 4000 });
  else setTimeout(go, 1500);
}
